import * as yup from 'yup';

export const schema = yup
  .object({
    cod_loja: yup.number(),
    tipo_periodo: yup.number(),
  })
  .required();
